import {DceComponent, DceHTMLElement} from "dce-engine";
import Dce from "dce-engine/lib/decorators/Dce";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

interface DataLayerEventsProps {
    events: {
        event: string;
        dataLayerEvent: any
    }[];
}

@Dce("dataLayerEvents")
export default class DataLayerEvents extends DceComponent<DataLayerEventsProps> {

    constructor(elem: DceHTMLElement, props: DataLayerEventsProps) {
        super(elem, props);


        props.events.forEach(value => {
            this.elem.addEventListener(value.event, () => {
                console.log('SEND: ', value.event, value.dataLayerEvent);

                if (
                    window.hasOwnProperty('dataLayer')
                    && Array.isArray(window.dataLayer)
                ) {
                    window.dataLayer.push(value.dataLayerEvent);
                }
            });
        });

    }

}